// Frontend
import PropTypes from 'prop-types';
import '../stylesheets/components/ProgressBar.css';

const ProgressBar = ({ loading }) => {
  return (
    <>
      {loading && (
        <div className="util--progress-bar">
          <div className="util--progress-bar__inner"></div>
        </div>
      )}
    </>
  );
};

ProgressBar.propTypes = {
  loading: PropTypes.bool.isRequired
};

export default ProgressBar;
